import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatStepperModule } from '@angular/material/stepper';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogCloseModule } from 'src/app/shared/components/dialog-close/dialog-close.module';
import { DialogConfirmModule } from 'src/app/shared/components/dialog-confirm/dialog-confirm.module';
import { DialogSaveCloseModule } from 'src/app/shared/components/dialog-save-close/dialog-save-close.module';
import { DynamicFormModule } from 'src/app/shared/components/dynamic-form/dynamic-form.module';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { TableResponsiveModule } from 'src/app/shared/components/table-responsive/table-responsive.module';
import { CardGridResponsiveModule } from 'src/app/shared/components/card-grid-responsive/card-grid-responsive.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { LayoutCrudIndexModule } from '../shared/layout-crud-index/layout-crud-index.module';
import { SystemModuleService } from '../system-modules/crud-service';
import { PlanCESComponent } from './crud-ces/crud-ces.component';
import { PlanEditReasonDialogModule } from './crud-ces/plan-edit-reason-dialog/plan-edit-reason-dialog.module';
import { PlanCrudIndex } from './crud-index/crud-index';
import { PlanIndexSelectComponent } from './crud-index/crud-index-select.component';
import { PlanIndexComponent } from './crud-index/crud-index.component';
import { PlanCreationDialogModule } from './crud-index/plan-creation-dialog/plan-creation-dialog.module';
import { PlanDetailsModule } from './crud-index/plan-details/plan-details.module';
import { PlanSelectionWizardComponent } from './plan-selection-wizard/plan-selection-wizard.component';
import { PlanSummaryDialogComponent } from './plan-summary-dialog/plan-summary-dialog.component';
import { PlanSolutionModulesDialogComponent } from './plan-solution-modules-dialog/plan-solution-modules-dialog.component';
import { PlanBranchCompositionDialogComponent } from './plan-branch-composition-dialog/plan-branch-composition-dialog.component';
import { PlansRoutingModule } from './plans-routing.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    PlanCESComponent,
    PlanCrudIndex,
    PlanIndexComponent,
    PlanIndexSelectComponent,
    PlanSelectionWizardComponent,
    PlanSummaryDialogComponent,
    PlanSolutionModulesDialogComponent,
    PlanBranchCompositionDialogComponent,
  ],
  imports: [
    CommonModule,
    PlansRoutingModule,
    AngularMaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormModule,
    FieldsModule,
    TableResponsiveModule,
    CardGridResponsiveModule,
    DialogCloseModule,
    DialogSaveCloseModule,
    DialogContainerModule,
    LayoutCrudIndexModule,
    PlanEditReasonDialogModule,
    PlanDetailsModule,
    PlanCreationDialogModule,
    DialogConfirmModule,
    MatDatepickerModule,
    MatStepperModule,
    MatTooltipModule,
  ],
  exports: [
    PlanSelectionWizardComponent
  ],
  providers: [
    SystemModuleService
  ]
})
export class PlansModule { }
